module.exports = __webpack_public_path__ + "images/Long Rectangle.svg";